import { Theme, responsiveFontSizes } from '@mui/material';
import { ComponentsOverrides, createTheme } from '@mui/material/styles';
import { dark, light } from './palette';
import shadows from './shadows';

const getTheme = (mode: string, themeToggler: () => void): Theme =>
    responsiveFontSizes(
        createTheme(
            {
                palette: mode === 'light' ? light : dark,
                shadows: shadows(mode),
                typography: {
                    fontFamily: [
                        '"Arial"',
                        'Nunito',
                        'Roboto',
                        'Helvetica Neue',
                        'sans-serif',
                        'Aref Ruqaa Ink',
                    ].join(','),
                    //fontSize: 16,
                    fontWeightRegular: 400,
                    fontWeightLight: 300,
                    fontWeightMedium: 500,
                    fontWeightBold: 700,
                    button: {
                        textTransform: 'none',
                        fontWeight:
                            'medium' as React.CSSProperties['fontWeight'],
                    },
                    h1: {
                        fontSize: 30,
                    },
                    h2: {
                        fontSize: 28,
                    },
                    h3: {
                        fontSize: 24,
                    },
                    h4: {
                        fontSize: 22,
                    },
                    h5: {
                        fontSize: 20,
                    },
                    h6: {
                        fontSize: 19,
                    },
                    body1: {
                        fontSize: 16,
                    },
                    body2: {
                        fontSize: 20,
                    },
                },
                zIndex: {
                    appBar: 1200,
                    drawer: 1300,
                },
                spacing: 8,
                shape: {
                    borderRadius: 4,
                },

                components: {
                    MuiButton: {
                        styleOverrides: {
                            root: {
                                //fontSize: 18,
                                fontWeight: 400,
                                borderRadius: 5,
                                paddingLeft: 25,
                                paddingRight: 25,
                                paddingTop: 5,
                                paddingBottom: 5,
                            },
                            // containedSecondary:
                            //     mode === 'light' ? { color: 'white' } : {},
                        } as ComponentsOverrides['MuiButton'],
                    },
                    MuiInputBase: {
                        styleOverrides: {
                            root: {
                                borderRadius: 5,
                            },
                        } as ComponentsOverrides['MuiInputBase'],
                    },
                    MuiOutlinedInput: {
                        styleOverrides: {
                            root: {
                                borderRadius: 5,
                                zIndex: 9,
                                backgroundColor: 'common.white',
                            },
                            
                            input: {
                                borderRadius: 5,
                                zIndex: 9,
                                backgroundColor: 'common.white',
                             },
                        } as ComponentsOverrides['MuiOutlinedInput'],
                    },
                    MuiCard: {
                        styleOverrides: {
                            root: {
                                borderRadius: 10,
                            },
                        } as ComponentsOverrides['MuiCard'],
                    },
                },
            },
            { themeToggler },
        ),
    );

export default getTheme;
